import type { EmailValidationCode } from "sandbox/types";

import { COMPETITOR_DOMAINS, FREE_EMAIL_DOMAINS } from "sandbox/constants";

const domainOf = (email: string): string | null => {
  const at = email.lastIndexOf("@");
  if (at === -1 || at === email.length - 1) return null;
  return email
    .slice(at + 1)
    .trim()
    .toLowerCase();
};

export const checkEmailDomain = (
  email: string,
): { code: EmailValidationCode; message?: string } => {
  const domain = domainOf(email);
  if (!domain) return { code: "ok" };
  if (FREE_EMAIL_DOMAINS.includes(domain)) {
    return {
      code: "free",
      message:
        "Use your work email — personal providers (Gmail, Yahoo, Outlook, etc.) aren't accepted",
    };
  }
  if (COMPETITOR_DOMAINS.includes(domain)) {
    return {
      code: "competitor",
      message: `Email addresses on ${domain} aren't eligible for sandbox access`,
    };
  }
  return { code: "ok" };
};
